export default [
  {
    name: "low",
    label: "Low",
  },
  {
    name: "normal",
    label: "Normal",
  },
  {
    name: "high",
    label: "High",
  },
  {
    name: "urgent",
    label: "Urgent",
  },
];
